import { useEffect } from 'react';

import type { FC } from 'react';

import { errorLog } from '@/lib/errorLog';
import { logger } from '@/services/logger';
import { toThrownReport } from '@/utils/errorLog';

const ErrorReporter: FC = () => {
  useEffect(() => {
    const onError = (event: ErrorEvent) => {
      logger.error(`window.error — ${event.message}`, event.error);
      errorLog.report(toThrownReport('window', 'window_error', event.error ?? event.message));
    };

    const onRejection = (event: PromiseRejectionEvent) => {
      logger.error('window.unhandledrejection', event.reason);
      errorLog.report(toThrownReport('window', 'unhandled_rejection', event.reason));
    };

    window.addEventListener('error', onError);
    window.addEventListener('unhandledrejection', onRejection);

    return () => {
      window.removeEventListener('error', onError);
      window.removeEventListener('unhandledrejection', onRejection);
    };
  }, []);

  return null;
};

export {
  ErrorReporter,
};
